<template>
  <div class="home">
    <section class="cards">
      <div class="card volunteer">
        <div class="card-img">
          <picture>
            <source srcset="../assets/img/VolunteerCover.webp" type="image/webp">
            <source srcset="../assets/img/volunteerCover.png" type="image/png"> 
            <img width="1200px" height="800px" src="../assets/img/volunteerCover.png" alt="volunteer with us"/>
          </picture> 
        </div>
        <!-- <h2>Become A Volunteer</h2> -->
        <p>Try new things, learn skills and be a role model for girls. Give your time to make guiding happen.</p>
        <a href="https://go.girlguiding.org.uk/join-us/join-as-volunteer/">Register Your Interest</a>
      </div>
      <div class="card join">
         <div class="card-img">
          <picture>
            <source srcset="../assets/img/RegisterDaugther.webp" type="image/webp">
            <source srcset="../assets/img/RegisterDaugther.png" type="image/png"> 
            <img width="1200px" height="800px" src="../assets/img/RegisterDaugther.png" alt="Join with us"/>
          </picture>
          </div>
        <!-- <h2>Join Us Today</h2> -->
        <p>Girls in guiding do unforgettable things. Register your daughter now to find a local group.</p>
        <a href="https://go.girlguiding.org.uk/join-us/join-as-member/">Register Your Daughter</a>
      </div>
    </section>
    <section class="cards">
      <div class="card rainbow">
        <h2>Rainbows</h2>
        <p>For girls aged five to seven – Rainbows is exciting, messy, friendly and a lot of fun!</p>
        <a href="https://www.girlguiding.org.uk/what-we-do/rainbows-5-7/">Find Out More!</a>
      </div>
      <div class="card brownie">
        <h2>Brownies</h2>
        <p>For girls aged seven to ten – being a Brownie is an adventurous journey that girls take with their friends!</p>
        <a href="https://www.girlguiding.org.uk/what-we-do/brownies-7-10/">Find Out More!</a>
      </div>
      <div class="card guide">
        <h2>Guides</h2>
        <p>For girls aged 10 to 14 – Guides challenge themselves and make a difference in their community.</p>
        <a href="https://www.girlguiding.org.uk/what-we-do/guides-10-14/">Find Out More!</a>
      </div>
      <div class="card ranger">
        <h2>Rangers</h2>
        <p>For young women aged 14 to 18, Rangers take the lead and finding new challenges.</p>
        <a href="https://www.girlguiding.org.uk/what-we-do/rangers/">Find Out More!</a>
      </div>
      
      <div class="card trefoil">
       <h2>Trefoil</h2>
       <p>The Trefoil Guild is part of Girlguiding UK but has a separate constitution and is independently administered.</p>
       <a href="https://www.trefoilguild.co.uk/">Find Out More!</a>
      </div> 
      <div class="card youngleader">
       <h2>Young Leaders</h2>
       <p>If you're between 14 and 18, develop your leadership skills while supporting a local unit with the Young Leader qualification</p>
       <a href="https://www.girlguiding.org.uk/what-we-do/rangers/young-leader-qualification/">Find Out More!</a>
      </div> 
      <div class="card adults">
       <h2>Guiding for Young Women (18+)</h2>
       <p>Whether you’re looking for adventure, to travel the world, build your skills or simply have fun with new friends, there’s a place in Girlguiding for you. </p>
       <a href="https://www.girlguiding.org.uk/what-we-do/young-women/">Find Out More!</a>
      </div> 
    </section>
  </div>
</template>

<script>
import { settingsRef } from '@/admin/firebase_config'
import appHeader from '@/app/components/appHeader'
import appFooter from '@/app/components/appFooter'
import sectionWork from '@/app/components/sectionWork'
import sectionService from '@/app/components/sectionService'
import sectionReview from '@/app/components/sectionReview'
import contentFetch from '@/admin/mixins/contentFetch'

export default {
  name: 'home',
  data () {
    return {
    }
  },
  mixins: [contentFetch],
  components: {
    appHeader,
    sectionWork,
    sectionService,
    sectionReview,
    appFooter
  },
  created:function(){
        // this.method1() //method1 will execute at pageload
  },
  firebase: {
    // load settings as object instead of array (default)
    settings: {
      source: settingsRef,
      asObject: true
    }
  },
  methods:{}
}

</script>

<style lang="scss" scoped>
@import '@/app/styles/index.scss';

.cards{
  width: 100%;
  max-width: 1200px;
  margin: auto;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content:center;
  align-items:stretch;
}

/**.card styling */
.card{
  flex: 2 2 20em;
  margin: 10px;
  // padding: 20px;
  width: auto;
  // max-width: 900px;
  text-align: center;
  height: auto;
  border-radius: 10px;
  flex-grow: 1;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
.card h2{
  color:white;
  padding:20px 10px;
  font-size: 28px;
  font-weight: 600;
}
.card p {
  margin: auto;
  padding: 20px 30px;
  font-weight: 400;
}
.card a {
  margin:10px;
  border:solid 2px white;
  background-color:#4e88c7;
  color:white;
  padding: 10px;
  border-radius: 10px;
  display:inline-block;
}
.rainbow{
  background-color: #ef3f30;
  color:white;
}
.rainbow a{
  background-color:#abe1fa;
  color:black;
}
.brownie{
  background-color: #ffd400;
  h2{
  color:black;
}
}
.brownie a{
  background-color:#7c5c23;
  color:white;
}
.guide{
  background-color:#0072bc;
  color:white;
}
.guide a{
  background-color:#ed1c24;
  color:white;
}
.ranger{
  background-color:#009dad;
  color:white;
}
.ranger a{
  background-color:#a7a9ac;
}
.trefoil{
  background-color: #d88d2a;
  color:white;
  h2{
  // background-color:$color-blue;
  color:white;
}
}
.trefoil a {
  background-color: #d71635;
  // color:white;
}
.youngleader{
  background-color: #646584;
  color:white;
  h2{
  // background-color:$color-blue;
  color:white;
}
}
.youngleader a {
  background-color: #d4d2d3;
  color:black;
}
.adults{
  flex: 1 1 20em;
  background-color:#ffffff;
  color:black;
}
.adults h2{
  // background-color:$color-blue;
  color:$color-blue;
}
.adults a{
  background-color:$color-pink;
}
.card-img{
  max-width: 800px;
}
.join{
  // flex: 3 3 20em;
  a{
    background:$color-pink;
  }
}
.volunteer {
  // flex: 1 1 20em;
//   max-width: 400px;
}
</style>
